import React from 'react'
import PropTypes from 'prop-types'
import { QUESTIONS } from '../../../constants/messages'
import { REFINANCING_TOPIC_KEY } from '../../../constants/topicKeys'
import { OverlayQuestionsFooter } from '../../shared/Routing'

const propTypes = {
  type: PropTypes.string,
  years: PropTypes.number,
  term: PropTypes.number,
  rate: PropTypes.number,
  apr: PropTypes.number,
  yearsInHome: PropTypes.number,
  id: PropTypes.string,
}

const RefiDetailsFooter = ({ id }) => (
  <OverlayQuestionsFooter
    topic={QUESTIONS.refinanceTopic}
    topicKey={REFINANCING_TOPIC_KEY}
    questions={[QUESTIONS.refinanceCashout, QUESTIONS.refinanceRecoup]}
    placeholder
    id={id}
  />
)

RefiDetailsFooter.propTypes = propTypes

export default RefiDetailsFooter
